import { FC, ReactNode } from 'react';
import { MenuCloseContext } from './helpers';

interface Props {
  children: ReactNode;
  value: (() => void) | null;
}

export const MenuProvider: FC<Props> = ({ children, value }) => {
  return <MenuCloseContext.Provider value={value}>{children}</MenuCloseContext.Provider>;
};
